import request from '@/utils/request'

// 查询列表
export function apiRoutingCalendarList (query) {
  return request({
    url: '/bom/routingCalendar/list',
    method: 'get',
    params: query
  })
}

// 新增弹窗-日历名称
export function apiRoutingCalendarPullDownList (query) {
  return request({
    url: '/bom/routingCalendar/pullDownList',
    method: 'get',
    params: query
  })
}

// 新增弹窗-班次名称
export function apiRoutingCalendarShiftsPullDownList (query) {
  return request({
    url: '/bom/routingCalendar/shiftsPullDownList',
    method: 'get',
    params: query
  })
}

// 新增弹窗-获取工作日历详情
export function apiRoutingCalendarId (id) {
  return request({
    url: `/bom/routingCalendar/${id}`,
    method: 'get'
  })
}

// 新增
export function apiRoutingCalendarAdd (data) {
  return request({
    url: '/bom/routingCalendar',
    method: 'post',
    data: data
  })
}

// 修改
export function apiRoutingCalendarEditCalendar (data) {
  return request({
    url: '/bom/routingCalendar/editCalendar',
    method: 'put',
    data: data
  })
}

// 删除
export function apiRoutingCalendarDelete (id) {
  return request({
    url: `/bom/routingCalendar?id=${id}`,
    method: 'delete'
  })
}

// 工作日历详情-保存
export function apiRoutingCalendarUpdate (data) {
  return request({
    url: '/bom/routingCalendar',
    method: 'put',
    data: data
  })
}
